import { Content, Icon, Task } from '../styles';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import { TaskCardProps } from '../../../../interfaces/ProjectInterface';

export default function TaskCard(Props: TaskCardProps) {
  // Other variables
  const { heading, count, iconName, iconViewBox = '0 0 18 18', iconFill } = Props;
  return (
    <Task>
      <Icon>
        <SVGIcon name={iconName} width='28' height='28' viewBox={iconViewBox} fill={iconFill} />
      </Icon>
      <Content>
        <p>{heading}</p>
        <h2>{count}</h2>
      </Content>
    </Task>
  );
}
